'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssureDeclare = function (_Component) {
  (0, _inherits3.default)(AssureDeclare, _Component);

  function AssureDeclare() {
    (0, _classCallCheck3.default)(this, AssureDeclare);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AssureDeclare).call(this));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  (0, _createClass3.default)(AssureDeclare, [{
    key: 'render',
    value: function render() {
      var styles = require('./AssureDeclare.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.tactTitle },
          '承诺声明'
        ),
        _react2.default.createElement('div', { className: styles.tactLink }),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          '1 、我们承诺在购物全程照顾您。',
          _react2.default.createElement('br', null),
          '2 、我们承诺为您提供公平，公正，透明的交易平台。',
          _react2.default.createElement('br', null),
          '3 、我们承诺在您需要的时候能够快捷地找到我们，我们始终在您身边。',
          _react2.default.createElement('br', null),
          '4 、我们承诺一心一意地为您提供舒适、满意的服务。',
          _react2.default.createElement('br', null),
          '5 、我们承诺用公平公正的态度处理您的交易纠纷，保障您在购物过程中的权益。'
        )
      );
    }
  }]);
  return AssureDeclare;
}(_react.Component); /**
                      * Created by zfc on 2016/9/13.
                      */


exports.default = AssureDeclare;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AssureDeclare/AssureDeclare.js
 ** module id = 1440
 ** module chunks = 0
 **/